const clientGroups = [
  {
    segment: "Setor Público & Judiciário",
    icon: "ri-government-line",
    clients: [
      "TREs", "TRTs", "TJs", "Justiças Federais", "Ministérios Públicos",
      "SEFAZ", "SEPLAD", "EBSERH", "AFEAM", "TCEs",
      "PRODAP", "PGEs", "PGMs", "BANPARÁ", "BASA",
      "Defensorias Públicas", "Hospital Ophir Loyola",
    ],
  },
  {
    segment: "Sistema S & Entidades",
    icon: "ri-building-2-line",
    clients: [
      "Federações de Indústrias", "SESIs", "SENAIs", "SENACs", "SESCs",
      "SEBRAEs", "CREAs", "CRECIs", "CRCs", "SINDIFISCO",
    ],
  },
  {
    segment: "Saúde",
    icon: "ri-heart-pulse-line",
    clients: ["Unimed", "Sabin", "Beneficente Portuguesa", "Amaral Costa", "Hospital Adventista", "HSM"],
  },
  {
    segment: "Mineração & Metalurgia",
    icon: "ri-hammer-line",
    clients: ["Hydro", "Vale", "ITV", "ALUBAR", "OZ MINERALS"],
  },
  {
    segment: "Agronegócio & Florestal",
    icon: "ri-plant-line",
    clients: ["MARBORGES", "FloraPlac", "Agromax", "Pagrisa"],
  },
  {
    segment: "Educação",
    icon: "ri-graduation-cap-line",
    clients: ["UFPA", "IFPA", "FIBRA", "Equipe", "ESAMAZ", "CESUPA"],
  },
  {
    segment: "Varejo & Comércio",
    icon: "ri-shopping-bag-line",
    clients: [
      "DiCasa", "BEMOL", "Domestilar", "Mônaco",
      "Grupo Simões", "Nutriama", "Líder", "Formosa",
      "NORTE Refrigeração", "RR Refrigeração", "GDias",
    ],
  },
  {
    segment: "Comunicação & Imprensa",
    icon: "ri-tv-2-line",
    clients: ["TV Liberal (Globo)", "TV Equinócio (Record)", "Jornal Liberal"],
  },
];

export default function ClientsSection() {
  return (
    <section id="clientes" className="py-20 bg-[#000000]">
      {/* Top divider */}
      <div
        className="w-full h-px mb-20"
        style={{ background: "linear-gradient(to right, transparent, rgba(98,169,224,0.3), transparent)" }}
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest mb-4"
            style={{ color: "#62A9E0" }}
          >
            <div
              className="w-6 h-px"
              style={{ background: "linear-gradient(to right, #62A9E0, #4C86C2)" }}
            />
            Clientes
            <div
              className="w-6 h-px"
              style={{ background: "linear-gradient(to right, #62A9E0, #4C86C2)" }}
            />
          </div>
          <h2 className="text-4xl font-black text-white mb-4">
            Empresas que{" "}
            <span className="solus-gradient-text">confiam</span> na Solus IT
          </h2>
          <p className="text-white/55 max-w-xl mx-auto text-sm">
            Atendemos organizações de diferentes segmentos em todo o Brasil, entregando soluções tecnológicas de alta performance e segurança.
          </p>
        </div>

        {/* Segments Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {clientGroups.map((group) => (
            <div
              key={group.segment}
              className="rounded-xl px-6 py-5"
              style={{
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(98,169,224,0.12)",
              }}
            >
              {/* Segment header */}
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-lg shrink-0"
                  style={{
                    background: "rgba(98,169,224,0.1)",
                    border: "1px solid rgba(98,169,224,0.25)",
                    color: "#62A9E0",
                  }}
                >
                  <i className={`${group.icon} text-base`} />
                </div>
                <span className="text-sm font-bold text-white/75 leading-tight">
                  {group.segment}
                </span>
              </div>

              {/* Horizontal divider */}
              <div
                className="w-full h-px mb-4"
                style={{ background: "rgba(98,169,224,0.12)" }}
              />

              {/* Client tags — static wrap */}
              <div className="flex flex-wrap gap-2">
                {group.clients.map((client) => (
                  <span
                    key={client}
                    className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap"
                    style={{
                      background: "rgba(98,169,224,0.08)",
                      border: "1px solid rgba(98,169,224,0.2)",
                      color: "rgba(255,255,255,0.75)",
                    }}
                  >
                    {client}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { value: "17+", label: "Anos de experiência" },
            { value: "200+", label: "Clientes ativos" },
            { value: "10+", label: "Segmentos atendidos" },
            { value: "18+", label: "Estados do Brasil" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="rounded-xl py-6 px-4 text-center"
              style={{
                background: "rgba(98,169,224,0.05)",
                border: "1px solid rgba(98,169,224,0.15)",
              }}
            >
              <div className="text-3xl font-black solus-gradient-text mb-1">{stat.value}</div>
              <div className="text-xs font-medium text-white/50">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          className="mt-8 rounded-2xl px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6"
          style={{
            background: "rgba(98,169,224,0.05)",
            border: "1px solid rgba(98,169,224,0.18)",
          }}
        >
          <div>
            <h3 className="text-xl font-black text-white mb-1">
              Seja um cliente{" "}
              <span className="solus-gradient-text">Solus IT</span>
            </h3>
            <p className="text-sm text-white/50 max-w-md">
              Junte-se a mais de 200 organizações que confiam em nossas soluções tecnológicas em todo o Brasil.
            </p>
          </div>
          <a
            href="mailto:comercial@solus-it.com.br"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-lg font-bold text-sm text-white transition-opacity hover:opacity-80 shrink-0"
            style={{
              background: "linear-gradient(135deg, #62A9E0, #4C86C2)",
            }}
          >
            <i className="ri-mail-send-line text-base" />
            Entrar em contato
          </a>
        </div>
      </div>
    </section>
  );
}
